import { useFlag } from '@unleash/proxy-client-react';
import React from 'react';
import {
  Navigate, Route, Routes,
} from 'react-router-dom';
import useDecisionTreeContext from '../../../Contexts/DecisionTree/DecisionTreeContext/useDecisionTreeContext';
import useProjectIdContext from '../../../Contexts/ProjectContexts/ProjectIdContext/useProjectIdContext';
import Suspense from '../../../Suspense';
import DecisionTreeRouter from '../../DecisionTreeWindow/DecisionTreeRouter';
import PageErrorBoundary from './ErorrBoundary';
import NotificationPage from './Pages/NotificationPage';

const CardPage = React.lazy(() => import('./Pages/CardPage'));
const HomePage = React.lazy(() => import('./Pages/HomePage'));
const CardsPage = React.lazy(() => import('./Pages/CardsPage'));
const CommandPage = React.lazy(() => import('./Pages/CommandPage'));
const CompliancePage = React.lazy(() => import('./Pages/CompliancePage'));
const SettingsPage = React.lazy(() => import('./Pages/SettingsPage'));
const ContentRequestPage = React.lazy(() => import('./Pages/ContentRequestPage'));
const PerformancePage = React.lazy(() => import('./Pages/PerformancePage'));
const SessionsPage = React.lazy(() => import('./Pages/SessionsPage'));

export default function Router() {
  const summarySession = useFlag('summary-session');
  const { projectId } = useProjectIdContext();
  const { isMounted } = useDecisionTreeContext();

  if (!projectId) {
    return (
      <div>
        No project selected
      </div>
    );
  }

  if (isMounted === 'main') {
    return (<PageErrorBoundary><DecisionTreeRouter /></PageErrorBoundary>);
  }

  return (
    <Routes>
      <Route path="home/*" element={(<Suspense><PageErrorBoundary><HomePage projectId={projectId} /></PageErrorBoundary></Suspense>)} />
      <Route path="projects/:projectId/cards/:cardId" element={<Suspense><PageErrorBoundary><CardPage /></PageErrorBoundary></Suspense>} />
      <Route path="library/cards/:cardId" element={<Suspense><PageErrorBoundary><CardPage /></PageErrorBoundary></Suspense>} />
      <Route path="settings/*" element={<Suspense><PageErrorBoundary><SettingsPage /></PageErrorBoundary></Suspense>} />
      <Route path="requests/*" element={<Suspense><PageErrorBoundary><ContentRequestPage /></PageErrorBoundary></Suspense>} />
      <Route path="commands" element={<Suspense><PageErrorBoundary><CommandPage projectId={projectId} /></PageErrorBoundary></Suspense>} />
      <Route path="cards" element={<Suspense><PageErrorBoundary><CardsPage projectId={projectId} /></PageErrorBoundary></Suspense>} />
      <Route path="compliance/*" element={<Suspense><PageErrorBoundary><CompliancePage projectId={projectId} /></PageErrorBoundary></Suspense>} />
      <Route path="performance/*" element={<Suspense><PageErrorBoundary><PerformancePage /></PageErrorBoundary></Suspense>} />
      <Route path="notifications/:id" element={<PageErrorBoundary><NotificationPage /></PageErrorBoundary>} />
      {summarySession && <Route path="sessions/*" element={<Suspense><PageErrorBoundary><SessionsPage /></PageErrorBoundary></Suspense>} />}
      <Route path="*" element={<Navigate to="/home/content" replace />} />
    </Routes>
  );
}
